import { Component, inject, Input } from "@angular/core";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTableModule } from "@angular/material/table";
import { MatIconModule } from "@angular/material/icon";
import { AsyncPipe, DatePipe } from "@angular/common";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { RouterLink } from "@angular/router";
import { MatTooltip } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { MyMarketsService } from "../../../my-markets/my-markets.service";

@Component({
  selector: "app-m-table",
  imports: [MatPaginatorModule, MatTableModule, MatIconModule, DatePipe, MatProgressBarModule, RouterLink, AsyncPipe, MatTooltip, TranslateModule],
  templateUrl: "./m-table.component.html",
  styleUrl: "./m-table.component.scss",
})
export class MTableComponent {
  @Input() data: any[] = [];
  displayedColumns = ["action", "marketStartTime", "eventType", "event", "competition"];
  myMarketsService = inject(MyMarketsService);

  addToMyMarkets(marketId: string) {
    this.myMarketsService.storeMarket(marketId);
  }

  removeFromMyMarkets(marketId: string) {
    this.myMarketsService.removeMarket(marketId);
  }

  protected readonly String = String;
}
